import { useTranslation } from 'react-i18next';
import cn from '../utils/cn';
import { icons } from '../icons';
import KoobButton from './KoobButton';
import KoobEmptyState from './KoobEmptyState';

/** What shows instead of a page, or of the whole app, that could not load or
 * crashed: never a blank screen (KD-3991). */
export default function KoobLoadError({
  onRetry,
  fullScreen = false,
}: {
  onRetry: () => void;
  /** Before the app's layout exists (app start): the whole screen. */
  fullScreen?: boolean;
}) {
  const { t } = useTranslation('loadError');

  return (
    <div
      role="alert"
      className={cn(
        'flex w-full items-center justify-center p-4',
        fullScreen ? 'min-h-screen bg-navy-50' : 'min-h-[70vh]',
      )}
    >
      <KoobEmptyState
        variant="plain"
        icon={<i className={icons.warning} />}
        title={t('title')}
        description={t('description')}
      >
        <KoobButton variant="primary" onClick={onRetry}>
          {t('retry')}
        </KoobButton>
      </KoobEmptyState>
    </div>
  );
}
